var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cng-container\u003E{{ label }}\u003C\u002Fng-container\u003E";;return pug_html;};
module.exports = template;